module.exports = __webpack_public_path__ + "img/loading.5bc723f8.gif";